<template>
  <teleport to="body">
    <div class="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div class="bg-white rounded-lg shadow p-5 w-3/4 max-w-4xl h-3/4 flex flex-col">
        <h2 class="text-xl mb-4 font-semibold">Meeting Transcript</h2>
        <!-- Transcript summary -->
        <div v-if="transcript_summary" class="sensitive">
          <div class="text-md font-semibold">Transcript Summary:</div>
          <div class="text-sm">{{ transcript_summary }}</div>
        </div>
        <!-- Raw Transcript -->
        <div class="sensitive flex-1 overflow-auto border-t mt-4">
          <div class="text-md font-semibold mt-2">Raw Transcript:</div>
          <template v-if="parsedTranscript">
            <div
              v-for="(entry, index) in parsedTranscript"
              :key="index"
              class="transcript-entry mb-2 mt-2 text-sm"
            >
              <div class="timestamp text-gray-500 text-sm sensitive">{{ entry.timestamp }}</div>
              <div v-if="entry.speaker" class="speaker font-semibold"><span class="sensitive" data-spoof-kind="person">{{ entry.speaker }}</span>:</div>
              <div class="text sensitive">{{ entry.text }}</div>
            </div>
          </template>
          <div v-else class="mt-2 text-sm whitespace-pre-wrap sensitive">{{ transcription_text }}</div>
        </div>
        <div class="mt-4">
          <button @click="closeModal" class="flex justify-center font-semibold w-full bg-black text-white rounded">
            Close
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'TranscriptFormatter',
  props: {
    transcription_text: {
      type: String,
      required: true
    },
    transcript_summary: {
      type: String,
      required: false
    },
  },
  computed: {
    parsedTranscript() {
      if (this.transcription_text.startsWith('WEBVTT')) {
        const regex = /(\d{2}:\d{2}:\d{2}\.\d{3})\s*-->\s*\d{2}:\d{2}:\d{2}\.\d{3}\s*\n<v\s([^>]+)>([^<]+)<\/v>/g
        const matches = [...this.transcription_text.matchAll(regex)]
        if (matches.length > 0) {
          return matches.map(match => ({
            timestamp: match[1],
            speaker: match[2],
            text: match[3].trim()
          }))
        }
      }

      // Try standard VTT format
      const regex = /(\d{2}:\d{2}:\d{2}\.\d{3})\s*-->\s*\d{2}:\d{2}:\d{2}\.\d{3}\s*\n([^:]+):\s*([\s\S]*?)(?=\n\d{2}:\d{2}:\d{2}\.\d{3}\s*-->|$)/g
      const matches = [...this.transcription_text.matchAll(regex)]
      if (matches.length > 0) {
        return matches.map(match => ({
          timestamp: match[1],
          speaker: match[2].trim(),
          text: match[3].trim()
        }))
      }

      // Fallback: return raw text as single entry
      return null
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.transcript-entry {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.5rem
}
</style>